module.exports = __webpack_public_path__ + "static/media/logo.bb3d9a8e.svg";